import { render, staticRenderFns } from "./LindaMagazine.vue?vue&type=template&id=287389ce"
import script from "./LindaMagazine.vue?vue&type=script&lang=js"
export * from "./LindaMagazine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports